import { Injectable, Inject} from '@angular/core';

export class PolicyClientAdditionalFieldDO {

	public  id:Number = null;

    public  fieldKey:String = null;

    public  fieldValue:String = null;

    public  versionId:any = null;

    public  guid:String = null;

    public  createdDt:Date = null;

    public  updatedDt:Date = null;

    public  createdUser:String = null;

    public  updatedUser:String = null;
	
	public  getId():Number {
		return this.id;
	}

}

